// extracted by mini-css-extract-plugin
export default {"tabs_container":"volunteerstudyhistory_tabs_container__+ZZn9","tab_btn":"volunteerstudyhistory_tab_btn__A0MJv","active":"volunteerstudyhistory_active__S0Nx0"};